module.exports = __webpack_public_path__ + "img/next_icon.40b9a108.svg";